import { render, staticRenderFns } from "./e-organization-owner.vue?vue&type=template&id=977a1ea8&scoped=true&lang=pug&"
import script from "./e-organization-owner.vue?vue&type=script&lang=js&"
export * from "./e-organization-owner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977a1ea8",
  null
  
)

export default component.exports